export default __webpack_public_path__ + "static/media/niyama-n-logo.d9be83e3.svg";